<app-menu>
    <div class="grid-header">
      <div class="grid-title">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-envelope"></i>&nbsp;PCES EMAIL PENDING List -->
        <button (click)="pcesEmailLists()" style="background-color: rgb(244, 240, 245); color: black;" mat-raised-button color="primary">PCES EMAIL List</button><br><br>
        <mat-card-content>
          <div [formGroup]="search_client" style="display: flex ; justify-content: space-start; flex-wrap: wrap;">
              <span style="flex-basis: 100%; display: flex; justify-content: space-between;">
                  <mat-form-field style="width: 100%;">
                      <mat-label>Client Name:</mat-label>
                      <input matInput formControlName="clientname" placeholder="Start Typing...">
                  </mat-form-field>&nbsp;&nbsp;
                  <mat-form-field style="width: 100%;">
                    <mat-label>Email:</mat-label>
                    <input matInput formControlName="contact_email" placeholder="Start Typing...">
                </mat-form-field>                  
              </span>
          </div>
          <div style="width: 50%; display: flex; justify-content: flex-start; gap: 20px">
              <!-- Search Button -->
              <button (click)="search()" mat-raised-button color="primary" style="background-color:rgb(21, 4, 117); font-size: 12px;">
                <i class="fa-solid fa-magnifying-glass"></i>
                <span class="text">Search</span>
              </button>
            
              <!-- Reset Button -->
              <button mat-raised-button (click)="resetFilter()"  mat-raised-button color="primary" style="background-color:rgb(21, 4, 117); font-size: 12px;">
                <i class="fas fa-undo"></i>
                <span class="text">Reset</span>
              </button>
          </div>              
        </mat-card-content>           
      </div>        
      <div class="toolbar-actions">
        <button (click)="sendAllEmail()" style="background-color: rgb(125, 11, 160); " mat-raised-button color="primary">
          <i style="font-size: 15px;" class="fa-solid fa-envelope"></i>&nbsp;Send All Emails
        </button>
      </div>         
      <div class="toolbar-actions">
        <button (click)="deleteAllPendingEmail()" style="background-color: rgb(160, 11, 23); " mat-raised-button color="primary">
          <i style="font-size: 15px;" class="fa-solid fa-trash"></i>&nbsp;Delete All Pending Emails
        </button>
      </div>           
      <div class="toolbar-actions">
      </div>               
    </div>   
    <ag-grid-angular #agGrid
    style="width: 100%; height: 100%;"
    class="ag-theme-alpine"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [animateRows]="true"
    [rowData]="rowData"
    [rowModelType]="'serverSide'"
    [cacheBlockSize]="100"
    (gridReady)="onGridReady($event)"
    [masterDetail]="true" 
    [detailRowHeight]="350"
    >
    </ag-grid-angular>
  </app-menu>
